export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function toTitleFriendlyCase(str) {
  return str.replace(/([A-Z])/g, " $1").replace(/^./, function(str) {
    return str.toUpperCase();
  });
}

export function toTitleCaseFromSnakeCase(str) {
  return toTitleCase(str.replace(/_/g, " "));
}
